// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_uh-0";